import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'listingThumbnail'
})
export class ListingThumbnailPipe implements PipeTransform {

  transform(imageUrl: string): any {
    if (imageUrl.startsWith('https://ik.imagekit.io')) {
      return `${imageUrl}?tr=n-prop_thumbnail`
    } else {
      return imageUrl
    }
  }

}
